import { useContext } from 'react';
import { GlobalTextCopyContext } from '../GlobalTextCopyContext/GlobalTextCopyContext.esm.js';

var useGlobalTextCopy = function () {
    var _a = useContext(GlobalTextCopyContext).globalTextCopies, globalTextCopies = _a === void 0 ? {} : _a;
    var getByComponentName = function (componentName) {
        return globalTextCopies === null || globalTextCopies === void 0 ? void 0 : globalTextCopies[componentName];
    };
    return {
        getByComponentName: getByComponentName,
        globalTextCopies: globalTextCopies,
    };
};

export { useGlobalTextCopy };
//# sourceMappingURL=useGlobalTextCopy.esm.js.map
